import React, { useEffect } from "react";
import { useSemanticUiInputRef } from "utilities/hookutils";
import { Input, InputOnChangeData } from "semantic-ui-react";
import { PhosphorMagnifyingGlass } from "./PhosphorIcon";

interface Props {
  value: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => void
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void
  className?: string

  placeholder?: string
  focusOnMount?: boolean
  maxLength?: number
}

export const SearchInput = (props: Props) => {
  const semanticRef = useSemanticUiInputRef();

  useEffect(() => {
    if (props.focusOnMount) {
      semanticRef.ref.current.focus();
    }
  }, []);

  return <Input
    ref={semanticRef.refSetter}
    className={props.className}
    icon
    style={{ position: "relative" }}
    fluid
    placeholder={props.placeholder}
    onKeyDown={props.onKeyDown}
    onChange={props.onChange}
    value={props.value}
    maxLength={props.maxLength}
  >
    <input />
    <i className="icon" style={{ paddingTop: 6 }}>
      <PhosphorMagnifyingGlass />
    </i>
  </Input>
}